var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "error_404"
  }, [_c('div', {
    staticClass: "container-scroller"
  }, [_c('div', {
    staticClass: "container-fluid page-body-wrapper full-page-wrapper"
  }, [_c('div', {
    staticClass: "\n          content-wrapper\n          d-flex\n          align-items-center\n          text-center\n          error-page\n          bg-primary\n        "
  }, [_c('div', {
    staticClass: "row flex-grow"
  }, [_c('div', {
    staticClass: "col-lg-7 mx-auto text-white"
  }, [_c('div', {
    staticClass: "row align-items-center d-flex flex-row"
  }, [_c('div', {
    staticClass: "col-lg-6 text-lg-right pr-lg-4"
  }, [_c('h1', {
    staticClass: "display-1 mb-0"
  }, [_vm._v("404")])]), _c('div', {
    staticClass: "col-lg-6 error-page-divider text-lg-left pl-lg-4"
  }, [_c('h2', [_vm._v("很抱歉")]), _c('h3', {
    staticClass: "font-weight-light"
  }, [_vm._v(" 我們找不到您要訪問的頁面 ")])])]), _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-12 text-center mt-xl-2"
  }, [_c('a', {
    staticClass: "text-white font-weight-medium",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Back to home")])])])])])])])])]);
}]

export { render, staticRenderFns }